
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Atou", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $hrAmX = parcelRequire("hrAmX");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");



var $cbc8g = parcelRequire("cbc8g");


var $4c1VG = parcelRequire("4c1VG");


var $hezbO = parcelRequire("hezbO");

const $427034d7b28f52d2$export$41956b146268af93 = 'StorageEnforcementBanner';
const $427034d7b28f52d2$export$ed7cc0d417ee89e = 56;






var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");




const $d7df6725813311a1$var$STORAGE_ENFORCEMENT_BANNER_DISMISS_STATE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_STORAGE_ENFORCEMENT_BANNER;
const $d7df6725813311a1$var$getIsDismissed = ()=>{
    return String((0, $17wUi.confluenceLocalStorageInstance)?.getItem($d7df6725813311a1$var$STORAGE_ENFORCEMENT_BANNER_DISMISS_STATE_KEY)) === 'true';
};
const $d7df6725813311a1$export$68d0770641f356c5 = ({ currentUsage: currentUsage, skip: skip })=>{
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)($d7df6725813311a1$var$getIsDismissed);
    (0, $42omo.useEffect)(()=>{
        /**
		 * Reset the dismiss state if they have dismissed the banner + are outside the thresholds to see the dismissible banner
		 * The UX reasoning is to reshow the banner for:
		 *   1. they have dismissed -> gone below the warning threshold -> go back over
		 *   2. They have dismissed -> go above storage limit -> go back below to warning limit
		 */ if (isDismissed && (currentUsage < (0, $hezbO.CONFLUENCE_STORAGE_LIMITS).FREE * (0, $hezbO.WARNING_THRESHOLD) || currentUsage >= (0, $hezbO.CONFLUENCE_STORAGE_LIMITS).FREE)) {
            (0, $17wUi.confluenceLocalStorageInstance).setItem($d7df6725813311a1$var$STORAGE_ENFORCEMENT_BANNER_DISMISS_STATE_KEY, 'false');
            setIsDismissed(false);
        }
    }, [
        currentUsage,
        isDismissed
    ]);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem($d7df6725813311a1$var$STORAGE_ENFORCEMENT_BANNER_DISMISS_STATE_KEY, 'true');
        setIsDismissed(true);
    }, []);
    return {
        isDismissed: skip ? false : isDismissed,
        onDismiss: onDismiss
    };
};


function $dc582f1dc75a89b2$export$cf22e0af7f079363(bannerState = null) {
    const { currentUsage: currentUsage, loading: loading, error: error, gracePeriodEndDate: gracePeriodEndDate } = (0, $4c1VG.useGetCurrentStorageUsage)();
    const shouldRenderHard = currentUsage >= (0, $hezbO.CONFLUENCE_STORAGE_LIMITS).FREE && gracePeriodEndDate;
    let shouldRenderSoft = currentUsage >= (0, $hezbO.CONFLUENCE_STORAGE_LIMITS).FREE * (0, $hezbO.WARNING_THRESHOLD) && currentUsage < (0, $hezbO.CONFLUENCE_STORAGE_LIMITS).FREE;
    const { isDismissed: isDismissed, onDismiss: onDismiss } = (0, $d7df6725813311a1$export$68d0770641f356c5)({
        currentUsage: currentUsage,
        skip: !shouldRenderSoft
    });
    shouldRenderSoft && (shouldRenderSoft = !isDismissed); // If they havent dismissed the warning banner -> should see it
    const shouldRender = Boolean(shouldRenderHard || shouldRenderSoft);
    if (shouldRender) {
        bannerState?.show((0, $427034d7b28f52d2$export$41956b146268af93), (0, $427034d7b28f52d2$export$ed7cc0d417ee89e));
        (0, $cbc8g.addUFOCustomData)({
            isStorageEnforcementBannerDisplayed: true
        });
    } else bannerState?.hide((0, $427034d7b28f52d2$export$41956b146268af93));
    return {
        shouldRender: shouldRender,
        shouldRenderHard: shouldRenderHard,
        currentUsage: currentUsage,
        onDismiss: onDismiss,
        error: error,
        loading: loading
    };
}






var $aXWIB = parcelRequire("aXWIB");


var $1ytiN = parcelRequire("1ytiN");


var $53qVZ = parcelRequire("53qVZ");


var $euL71 = parcelRequire("euL71");





var $1eaCJ = parcelRequire("1eaCJ");















var $eEA8O = parcelRequire("eEA8O");


var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $9wGTI = parcelRequire("9wGTI");


var $7aTMs = parcelRequire("7aTMs");




const $21841235140626f3$export$822cdd78febe6c96 = (0, $aXWIB.defineMessages)({
    learnMoreLink: {
        id: "storage-enforcement.banner.learn-more",
        defaultMessage: "Learn more"
    }
});


const $2bb0cabca0713201$var$i18n = (0, $aXWIB.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    dismiss: {
        id: "storage-enforcement.banner.button.dismiss",
        defaultMessage: "Dismiss"
    },
    moreIcon: {
        id: "storage-enforcement.icons.more",
        defaultMessage: "More icon"
    }
});
const $2bb0cabca0713201$export$ef1a7cc86a1601cc = ({ handleDismiss: handleDismiss = ()=>{}, showDismiss: showDismiss, onLearnMoreClick: onLearnMoreClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    label: formatMessage($2bb0cabca0713201$var$i18n.moreIcon)
                }),
                ref: triggerRef
            }),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-trueadmin-experi')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        href: (0, $7aTMs.LEARN_MORE_URL),
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $21841235140626f3$export$822cdd78febe6c96).learnMoreLink)), showDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleDismiss
    }, formatMessage($2bb0cabca0713201$var$i18n.dismiss))));
};



var $jH0zq = parcelRequire("jH0zq");


var $jmjWc = parcelRequire("jmjWc");


const $8c203db23a1bec44$export$c06923be9f7b8317 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "U0Lbt",
    name: "PlanConsentDeepLink",
    loader: async ()=>(await (parcelRequire("ismGL"))).PlanConsentDeepLink
});














function $5236fcc009f490b1$export$d608ae2ec728a3cf({ children: children }) {
    const { fireLearnMoreEvent: fireLearnMoreEvent } = (0, $jH0zq.useBannerAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.BannerLink), {
        onClick: fireLearnMoreEvent,
        href: (0, $7aTMs.LEARN_MORE_URL),
        target: "_blank"
    }, children);
}


const $39f95f1f5c327e07$var$i18n = (0, $aXWIB.defineMessages)({
    adminHardMessageV2: {
        id: "storage-enforcement.banner.admin.hard.message.v2",
        defaultMessage: "Action required. You won\u2019t be able to create in Confluence soon, unless you upgrade for more storage or delete <b>{number} GB</b> of files by {date}. <a>Upgrade to Standard</a>"
    },
    adminHardEnforceMessage: {
        id: "storage-enforcement.banner.admin.hard.enforced.message",
        defaultMessage: "Action required. You can\u2019t edit or create new content in Confluence until you upgrade for more storage or delete <b>{number} GB</b> GB of files. <a>Upgrade to Standard</a>"
    },
    nthUserHardMessage: {
        id: "storage-enforcement.banner.nth-user.hard.message",
        defaultMessage: "Action required. You won\u2019t be able to create in Confluence soon unless you delete files by {date}. <a>Learn more</a>"
    },
    nthUserHardEnforceMessage: {
        id: "storage-enforcement.banner.nth-user.hard.enforced.message",
        defaultMessage: "Action required. You can\u2019t edit or create new content in Confluence until you delete files. <a>Learn more</a>"
    }
});
const $39f95f1f5c327e07$export$dd5b64b9e70297f9 = ()=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aXWIB.useIntl)();
    const { currentUsage: currentUsage, gracePeriodEndDate: gracePeriodEndDate, isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { fireLearnMoreEvent: fireLearnMoreEvent, fireScreenEvent: fireScreenEvent } = (0, $jH0zq.useBannerAnalytics)();
    // The date will always be set at this point because it was asserted higher.
    const date = formatDate(new Date(gracePeriodEndDate), {
        // todo get the date
        year: 'numeric',
        month: 'long',
        day: '2-digit'
    });
    const number = (0, $hezbO.getOverLimitFormatted)(currentUsage, (0, $euL71.ConfluenceEdition).FREE);
    (0, $42omo.useEffect)(()=>{
        fireScreenEvent();
    }, [
        fireScreenEvent
    ]);
    const adminMessage = isStorageEnforcementGracePeriodComplete ? $39f95f1f5c327e07$var$i18n.adminHardEnforceMessage : $39f95f1f5c327e07$var$i18n.adminHardMessageV2;
    const nthUserMessage = isStorageEnforcementGracePeriodComplete ? $39f95f1f5c327e07$var$i18n.nthUserHardEnforceMessage : $39f95f1f5c327e07$var$i18n.nthUserHardMessage;
    const description = isSiteAdmin ? formatMessage(adminMessage, {
        date: date,
        number: number,
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c203db23a1bec44$export$c06923be9f7b8317), null, chunks),
        b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    }) : formatMessage(nthUserMessage, {
        date: date,
        number: number,
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5236fcc009f490b1$export$d608ae2ec728a3cf), null, chunks)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.OnboardingWarningBanner), {
        bannerHeight: (0, $427034d7b28f52d2$export$ed7cc0d417ee89e),
        description: description,
        rightSideComponent: isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2bb0cabca0713201$export$ef1a7cc86a1601cc), {
            onLearnMoreClick: fireLearnMoreEvent,
            showDismiss: false
        })
    }));
};












var $hmuev = parcelRequire("hmuev");
































const $54eb5fc25a7cd80c$var$i18n = (0, $aXWIB.defineMessages)({
    closeIcon: {
        id: "storage-enforcement.icons.close",
        defaultMessage: "Close icon"
    },
    softMessageOver: {
        id: "storage-enforcement.banner.soft.message.over",
        defaultMessage: "You\u2019ve exceeded the 2GB storage limit for your Free plan."
    },
    softMessageUnderV2: {
        id: "storage-enforcement.banner.soft.message.under.v2",
        defaultMessage: "You\u2019ve used <b>{number}%</b> of the Free plan\u2019s 2 GB storage limit."
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    upgradeForMoreStorage: {
        id: "storage-enforcement.banner.button.upgrade-for-more-storage",
        defaultMessage: "Upgrade for more storage"
    }
});
const $54eb5fc25a7cd80c$export$5261b8ecdbc8f820 = ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { currentUsage: currentUsage } = (0, $4c1VG.useGetCurrentStorageUsage)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { fireLearnMoreEvent: fireLearnMoreEvent, fireDismissEvent: fireDismissEvent, fireScreenEvent: fireScreenEvent } = (0, $jH0zq.useBannerAnalytics)();
    (0, $42omo.useEffect)(()=>{
        fireScreenEvent();
    }, [
        fireScreenEvent
    ]);
    const handleDismiss = ()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_DISMISS_EXPERIENCE)
        });
        try {
            fireDismissEvent();
            onDismiss();
            experienceTracker.succeed({
                name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_DISMISS_EXPERIENCE)
            });
        } catch (error) {
            experienceTracker.stopOnError({
                name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_DISMISS_EXPERIENCE),
                error: error
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.OnboardingWarningBanner), {
        bannerHeight: (0, $427034d7b28f52d2$export$ed7cc0d417ee89e),
        description: formatMessage($54eb5fc25a7cd80c$var$i18n.softMessageUnderV2, {
            number: (0, $hezbO.getStoragePercentForEdition)(currentUsage, (0, $euL71.ConfluenceEdition).FREE),
            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }),
        inlineDescriptionCTA: isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c203db23a1bec44$export$c06923be9f7b8317), null, formatMessage($54eb5fc25a7cd80c$var$i18n.upgradeForMoreStorage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5236fcc009f490b1$export$d608ae2ec728a3cf), null, formatMessage((0, $21841235140626f3$export$822cdd78febe6c96).learnMoreLink)),
        rightSideComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2bb0cabca0713201$export$ef1a7cc86a1601cc), {
            onLearnMoreClick: fireLearnMoreEvent,
            handleDismiss: handleDismiss,
            showDismiss: true
        }), !isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            onClick: handleDismiss,
            onMouseDown: (e)=>e.preventDefault(),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: formatMessage($54eb5fc25a7cd80c$var$i18n.closeIcon)
            })
        }))
    }));
};


const $49a41f747aacdbdd$var$StorageEnforcementBannerContainer = /*#__PURE__*/ (0, $42omo.memo)(({ bannerState: bannerState })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { shouldRender: shouldRender, shouldRenderHard: shouldRenderHard, error: error, loading: loading, onDismiss: onDismiss } = (0, $dc582f1dc75a89b2$export$cf22e0af7f079363)(bannerState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (error) {
        experienceTracker.stopOnError({
            name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_EXPERIENCE),
            error: error,
            attributes: {
                shouldRender: shouldRender,
                shouldRenderHard: shouldRenderHard,
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                isSSR: undefined
            }
        });
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        }
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'storageEnforcementBanner',
                source: 'onboarding',
                attributes: {
                    message: error.message,
                    stack: error.stack
                }
            }
        }).fire();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    if (!shouldRender) {
        if (!loading) /**
       * No render of the banner an abort to differentiate it from an actual render.
       * this scenario it means that none of the queries errored out.
       */ experienceTracker.abort({
            name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_EXPERIENCE),
            reason: 'under storage enforcement threshold'
        });
        return null;
    }
    return shouldRenderHard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39f95f1f5c327e07$export$dd5b64b9e70297f9), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $54eb5fc25a7cd80c$export$5261b8ecdbc8f820), {
        onDismiss: onDismiss
    });
});
const $49a41f747aacdbdd$export$8140039602269ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BANNER_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49a41f747aacdbdd$var$StorageEnforcementBannerContainer, {
            bannerState: bannerState
        })));
module.exports["StorageEnforcementBanner"] = $49a41f747aacdbdd$export$8140039602269ff0;

});

parcelRegister("hezbO", function(module, exports) {

var $euL71 = parcelRequire("euL71");

const $115d6e303e7a4434$var$GB_SIZE = 10 ** 9;
const $115d6e303e7a4434$export$bd2f6ae58451688b = 0.9;
var $115d6e303e7a4434$export$4e49711b2a6ab8bc = /*#__PURE__*/ function(CONFLUENCE_STORAGE_LIMITS) {
    CONFLUENCE_STORAGE_LIMITS[CONFLUENCE_STORAGE_LIMITS["FREE"] = 2000000000] = "FREE";
    CONFLUENCE_STORAGE_LIMITS[CONFLUENCE_STORAGE_LIMITS["STANDARD"] = 250000000000] = "STANDARD";
    return CONFLUENCE_STORAGE_LIMITS;
}({});
const $115d6e303e7a4434$export$56b13eff4ca10319 = {
    [(0, $euL71.ConfluenceEdition).FREE]: 2000000000,
    [(0, $euL71.ConfluenceEdition).STANDARD]: 250000000000
};
const $115d6e303e7a4434$export$59b523a473b278c8 = (currentUsage, edition)=>{
    const editionLimit = $115d6e303e7a4434$export$56b13eff4ca10319[edition];
    const difference = (currentUsage - editionLimit) / $115d6e303e7a4434$var$GB_SIZE;
    return (difference < 0 ? 0 : difference).toFixed(1);
};
const $115d6e303e7a4434$export$14944f0df593380a = (currentUsage, edition)=>{
    const editionLimit = $115d6e303e7a4434$export$56b13eff4ca10319[edition];
    const percent = (currentUsage - editionLimit) / editionLimit * 100;
    return percent.toFixed(1);
};
const $115d6e303e7a4434$export$636a0445970e0e1c = (currentUsage, edition)=>{
    const editionLimit = $115d6e303e7a4434$export$56b13eff4ca10319[edition];
    const storagePercent = Math.floor(currentUsage / editionLimit * 100);
    return storagePercent > 100 ? 100 : storagePercent;
};
const $115d6e303e7a4434$export$a8fa80e25e9c2c0c = (currentUsage, edition)=>currentUsage > $115d6e303e7a4434$export$56b13eff4ca10319[edition];
module.exports["WARNING_THRESHOLD"] = $115d6e303e7a4434$export$bd2f6ae58451688b;
module.exports["CONFLUENCE_STORAGE_LIMITS"] = $115d6e303e7a4434$export$4e49711b2a6ab8bc;
module.exports["getOverLimitFormatted"] = $115d6e303e7a4434$export$59b523a473b278c8;
module.exports["getOverLimitPercent"] = $115d6e303e7a4434$export$14944f0df593380a;
module.exports["getStoragePercentForEdition"] = $115d6e303e7a4434$export$636a0445970e0e1c;
module.exports["getIsOverEditionLimit"] = $115d6e303e7a4434$export$a8fa80e25e9c2c0c;

});

parcelRegister("53qVZ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $aXWIB = parcelRequire("aXWIB");


var $ebrpi = parcelRequire("ebrpi");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d973bb5650e905e2$var$BannerContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const t3 = `${__cmplp.height}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1neqek2": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q71917 _1yt4utpp _zulp1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _syazi7uo _4t3i2nrh _vchhusvi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $d973bb5650e905e2$export$aa2fe30df074b213 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syazi7uo _80omtlke _o5721q9c _d16pv77o _7b0b1i6y _30l3i7uo _1053i7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d973bb5650e905e2$var$TextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _zulp1b66 _1e0c1txw _4cvr1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d973bb5650e905e2$var$DescriptionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d973bb5650e905e2$var$i18n = (0, $aXWIB.defineMessages)({
    warningIcon: {
        id: "banners.icons.warning",
        defaultMessage: "Warning icon"
    },
    moreIcon: {
        id: "banners.icons.more",
        defaultMessage: "More icon"
    },
    closeIcon: {
        id: "banners.icons.close",
        defaultMessage: "Close icon"
    }
});
const $d973bb5650e905e2$export$81bad57c302cbb8f = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { bannerHeight: bannerHeight, description: description, inlineDescriptionCTA: inlineDescriptionCTA, rightSideComponent: rightSideComponent } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($d973bb5650e905e2$var$i18n.warningIcon);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            spacing: "spacious",
            label: t1,
            color: "var(--ds-icon-warning, #E06C00)"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== description) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d973bb5650e905e2$var$DescriptionContainer, null, description);
        $[4] = description;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== inlineDescriptionCTA || $[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d973bb5650e905e2$var$TextContainer, null, t2, t3, inlineDescriptionCTA);
        $[6] = inlineDescriptionCTA;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== bannerHeight || $[11] !== rightSideComponent || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d973bb5650e905e2$var$BannerContentContainer, {
            height: bannerHeight
        }, t4, rightSideComponent);
        $[10] = bannerHeight;
        $[11] = rightSideComponent;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};
module.exports["BannerLink"] = $d973bb5650e905e2$export$aa2fe30df074b213;
module.exports["OnboardingWarningBanner"] = $d973bb5650e905e2$export$81bad57c302cbb8f;

});

parcelRegister("7aTMs", function(module, exports) {
const $3b4d7e6e8676573f$export$ad44d4a0591d8dba = 'onboarding';
const $3b4d7e6e8676573f$export$af6d68522cb370b8 = 'https://support.atlassian.com/confluence-cloud/docs/manage-your-storage-usage/';
module.exports["EVENT_SOURCE"] = $3b4d7e6e8676573f$export$ad44d4a0591d8dba;
module.exports["LEARN_MORE_URL"] = $3b4d7e6e8676573f$export$af6d68522cb370b8;

});

parcelRegister("jH0zq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $euL71 = parcelRequire("euL71");


var $1ytiN = parcelRequire("1ytiN");


var $hezbO = parcelRequire("hezbO");

var $8d59f1783ec635e5$export$6fd66866056b2469 = /*#__PURE__*/ function(BannerThresholds) {
    BannerThresholds[BannerThresholds["MIN"] = 90] = "MIN";
    BannerThresholds[BannerThresholds["MAX"] = 100] = "MAX";
    return BannerThresholds;
}({});
const $8d59f1783ec635e5$export$daeeed15a111ad8f = (currentUsage, edition)=>{
    return (0, $hezbO.getIsOverEditionLimit)(currentUsage, edition) ? 100 : 90;
};



var $7aTMs = parcelRequire("7aTMs");


var $4c1VG = parcelRequire("4c1VG");

const $1403587b01db7799$export$5fc4846deb361c80 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { currentUsage: currentUsage } = (0, $4c1VG.useGetCurrentStorageUsage)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const threshold = (0, $8d59f1783ec635e5$export$daeeed15a111ad8f)(currentUsage, (0, $euL71.ConfluenceEdition).FREE);
    const fireScreenEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'storageEnforcementBanner',
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    threshold: threshold
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        threshold
    ]);
    const fireLearnMoreEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'storageEnforcementBannerLearnMore',
                source: (0, $7aTMs.EVENT_SOURCE),
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    threshold: threshold
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        threshold
    ]);
    const fireUpgradeEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'storageEnforcementBannerUpgrade',
                source: (0, $7aTMs.EVENT_SOURCE),
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    threshold: threshold
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        threshold
    ]);
    const fireDismissEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'storageEnforcementBannerDismissed',
                source: (0, $7aTMs.EVENT_SOURCE),
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    threshold: threshold
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        threshold
    ]);
    return {
        fireUpgradeEvent: fireUpgradeEvent,
        fireLearnMoreEvent: fireLearnMoreEvent,
        fireDismissEvent: fireDismissEvent,
        fireScreenEvent: fireScreenEvent
    };
};
module.exports["useBannerAnalytics"] = $1403587b01db7799$export$5fc4846deb361c80;

});

parcelRegister("ismGL", function(module, exports) {

let $d6fc71035a410702$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6fc71035a410702$var$load("cGZdO").then(()=>parcelRequire('fYalI'));

});


//# sourceMappingURL=StorageEnforcementBanner.3b078288.js.map
